import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  selectFirstName,
  selectUserEmail,
} from '../../../redux/user-data/selectors';
import { changeUserData } from '../../../redux/user-data/operations';

import { IconButtonByContent } from 'components/common/Buttons/Buttons';
import icon from 'media/images/svgSprite.svg';

import {
  UserMenuHeadWrap,
  UserDataWrap,
  UserIconWrap,
  UserIcon,
  ArrowIcon,
  UserNameWrap,
  UserMeta,
  UserNameInput,
  EditIcon,
  UserMail,
  AccountList,
  AccountItem,
  AccountMark,
  AccountFirstLetter,
} from 'components/user/UserHeader/UserHeader.styled';

/**TODO:
 * Replace accountListData with data from the backend
 * Remove isTeamsExist
 */

const accountListData = [
  {
    id: '214',
    accountName: 'Anya',
    role: 'Owner',
  },
  {
    id: '211',
    accountName: 'Artem',
    role: 'Admin',
  },
  {
    id: '212',
    accountName: 'Bogdan',
    role: 'Editor',
  },
  {
    id: '213',
    accountName: 'Nik',
    role: 'Reader',
  },
  {
    id: '215',
    accountName: 'Max',
    role: 'Reader',
  },
];

const UserHeader = ({ orientation, pageType, onCloseMenu }) => {
  const [firstName, setFirstName] = useState(null);
  const [userEmail, setUserEmail] = useState('example@gmail.com');
  const [isUserNameChanging, setIsUserNameChanging] = useState(false);
  const [isListOpen, setIsListOpen] = useState(false);
  const [listStatus, setListStatus] = useState('close');

  const userName = useSelector(selectFirstName);
  const email = useSelector(selectUserEmail);
  const isTeamsExist = false;

  const dispatch = useDispatch();

  useEffect(() => {
    if (userName !== null) {
      setFirstName(userName);
    }
    if (email !== '') {
      setUserEmail(email);
    }
  }, [email, userName]);

  function onChangeName(e) {
    e.stopPropagation();
    setIsUserNameChanging(true);
  }

  function onSaveName(e) {
    e.stopPropagation();

    if (firstName !== userName) {
      dispatch(changeUserData({ first_name: firstName }));
    }
    setIsUserNameChanging(false);
  }

  function handleClickSelectionAccount(e) {
    e.stopPropagation();

    if (listStatus === 'close') {
      setListStatus('open');
      setIsListOpen(true);
    }

    if (listStatus === 'open') {
      onCloseAccountList();
    }
  }

  function handleSelectAccount(e, item) {
    e.stopPropagation();

    console.log('Switch to the account', item);

    onCloseMenu();
  }

  function onCloseAccountList() {
    setListStatus('close');

    setTimeout(() => {
      setIsListOpen(false);
    }, 400);
  }

  return (
    <UserMenuHeadWrap $orientation={orientation} $pageType={pageType}>
      <UserDataWrap>
        {pageType === 'menu' && isTeamsExist ? (
          <UserIconWrap
            type="button"
            $isListOpen={listStatus}
            $pageType={pageType}
            onClick={handleClickSelectionAccount}
          >
            <UserIcon $pageType={pageType}>
              <use href={`${icon}#icon-user_2`}></use>
            </UserIcon>
            <ArrowIcon>
              <use href={`${icon}#icon-arrow-cards`}></use>
            </ArrowIcon>
          </UserIconWrap>
        ) : (
          <UserIcon $pageType={pageType}>
            <use href={`${icon}#icon-user_2`}></use>
          </UserIcon>
        )}
        <UserMeta>
          <UserNameWrap>
            {isUserNameChanging ? (
              <>
                <UserNameInput
                  type="text"
                  onChange={e => setFirstName(e.target.value)}
                  onClick={e => e.stopPropagation()}
                  value={firstName || ''}
                  maxLength={17}
                />
                <IconButtonByContent
                  handleClick={onSaveName}
                  isDisabled={!firstName || firstName.trim() === ''}
                >
                  <EditIcon $type="check">
                    <use href={`${icon}#icon-check`}></use>
                  </EditIcon>
                </IconButtonByContent>
              </>
            ) : (
              <h5>{firstName || 'Name'}</h5>
            )}

            {!isUserNameChanging && (
              <IconButtonByContent handleClick={onChangeName}>
                <EditIcon $type="pencil">
                  <use href={`${icon}#icon-pencil`}></use>
                </EditIcon>
              </IconButtonByContent>
            )}
          </UserNameWrap>
          <UserMail>{userEmail}</UserMail>
        </UserMeta>
      </UserDataWrap>

      {isListOpen && (
        <AccountList
          $isListOpen={listStatus}
          $numberOfItems={accountListData.length}
        >
          {accountListData.map(item => {
            return (
              <li key={item.id}>
                <AccountItem onClick={e => handleSelectAccount(e, item)}>
                  <AccountMark>
                    <AccountFirstLetter>
                      {item.accountName[0]}
                    </AccountFirstLetter>
                  </AccountMark>
                  <p>
                    {item.accountName}
                    {item.role === 'Owner' && <span>{` (yours)`}</span>}
                  </p>
                </AccountItem>
              </li>
            );
          })}
        </AccountList>
      )}
    </UserMenuHeadWrap>
  );
};

export default UserHeader;
